import { GET_FOLLOWERS } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_FOLLOWERS:
            return action.payload;
        default:
            return state;
    }
}